'use client'

import { PaymentTermsInformationBottomSheet } from '@features/payment/ui/payment-terms-information-bottom-sheet'
import { useState } from 'react'

import { BottomSheetClose, BottomSheetRoot, BottomSheetTrigger, Button } from '@podo-app/design-system-temp'

// This is the KR service's legal notice, independent of the member's display language.
export function KrPaymentTermsNotice() {
  const [open, setOpen] = useState(false)
  return (
    <BottomSheetRoot open={open} onOpenChange={setOpen}>
      <p className="text-center text-xs text-gray-400 font-[200]" data-testid="kr-payment-terms-notice">
        결제 내역을 확인하였으며{' '}
        <BottomSheetTrigger asChild>
          <button type="button" className="text-gray-400 underline">
            이용약관
          </button>
        </BottomSheetTrigger>
        에 동의합니다.
      </p>
      {open && (
        <PaymentTermsInformationBottomSheet
          aria-label="이용약관"
          aria-labelledby={undefined}
          aria-describedby={undefined}
        >
          <BottomSheetClose asChild>
            <Button type="button" variant="ghost" className="mt-4 w-full">
              닫기
            </Button>
          </BottomSheetClose>
        </PaymentTermsInformationBottomSheet>
      )}
    </BottomSheetRoot>
  )
}
